import { useRef, useCallback } from "react"
import * as htmlToImage from "html-to-image"
import { saveAs } from "file-saver"

/**
 * 엘리먼트 블록 내의 콘텐츠 캡쳐
 * @param fileName 캡쳐 후 저장할 파일명
 * @param padding 캡처할 때 엘리먼트 주위에 추가할 여백 (px)
 * @param options html-to-image 옵션 (cacheBust, backgroundColor…)
 * @returns 파일 저장 프롬프트창 팝업
 */
//TODO @S3 버킷(CDN 포함)의 CORS 설정을 해줘야 정상적으로 캡처 가능 (유저의 프로필 이미지가 포함될 경우 오류. 현재 익명 캡쳐는 문제 없음)
export function useCaptureImage({
    fileName = "capture.png",
    padding = 0,
    options = {},
    onError,
} = {}) {
    const ref = useRef(null)

    const capture = useCallback(
        async (overrideName) => {
            if (!ref.current) return
            const node = ref.current

            // 모든 이미지 fetch → object URL로 교체 (src 체크 & 에러 무시)
            const imgs = Array.from(node.querySelectorAll("img"))
            await Promise.all(
                imgs.map(async (img) => {
                    const src = img.getAttribute("src")
                    if (
                        !src ||
                        src.startsWith("data:") ||
                        src.startsWith("blob:")
                    )
                        return
                    try {
                        const res = await fetch(src, { mode: "cors" })
                        const blob = await res.blob()
                        await new Promise((resolve) => {
                            const url = URL.createObjectURL(blob)
                            img.onload = () => resolve()
                            img.src = url
                        })
                    } catch (e) {
                        console.warn("--Image Fetch Skip:", src, e)
                    }
                })
            )

            // 폰트 로드 대기
            await document.fonts.load('1em "bootstrap-icons"')
            await document.fonts.ready

            // 엘리먼트 실제 크기 측정
            const rect = node.getBoundingClientRect()
            const pad = Number(padding) || 0
            htmlToImage
                .toPng(node, {
                    ...options,
                    // style 을 덮어씌워 padding 이 반영되게 함
                    style: {
                        cacheBust: true,
                        fontFamily: "bootstrap-icons",
                        padding: `${pad}px`,
                        ...(options.style || {}),
                    },
                    // 전체 캔버스 크기
                    width: rect.width + pad * 2,
                    height: rect.height + pad * 2,
                })
                .then((dataUrl) => saveAs(dataUrl, overrideName || fileName))
                .catch((err) => {
                    console.error("--Capture Failed:", err)
                    onError?.(err)
                })
        },
        [fileName, options, padding, onError]
    )

    return [ref, capture]
}
